import React from "react";
import { connect } from "react-redux";
import MainHeader from "editor/components/MainHeader";
import ToolsBar from "editor/components/ToolsBar";
import EditorFrame from "editor/components/EditorFrame";
// import SideMenu from "editor/components/SideMenu";

import { WorkbanchContainer, CustomPageContent } from "./styles";

const Workbanch = ({ id, iframeToken, iframeLoaded }) => {
  return (
    <WorkbanchContainer>
      <MainHeader />
      <CustomPageContent>
        <ToolsBar />
        {id && (
          <EditorFrame
            url={`${process.env.BASE_URL}/content/pages/${id}/iframe?iframe_token=${iframeToken}`}
          />
        )}
      </CustomPageContent>
    </WorkbanchContainer>
  );
};

const mapStatetoProps = state => ({
  id: state.page.id,
  iframeLoaded: state.editor.iframeLoaded,
  iframeToken: state.page.iframe_token
});

const mapDispatchToProps = {};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(Workbanch);
